export const url = 'https://dev.ashrafigold.com/'
// export const baseUrl = `https://cors-anywhere.herokuapp.com/${url}api`
export const baseUrl = `${url}api`
export const imageUrl = 'https://dev.ashrafigold.com'


export const urls = {
	login: '/tv/login',
	logout: '/tv/logout',
	getInfo: '/tv/info',
	getPrices: '/tv/price?type=IR',
	getFrPrices: '/tv/price?type=FR',
	getBanner: '/tv/banners',
	getChartsMenu: '/mobile/chart-menu',
	getChartsByType: '/mobile/chart?type=GOLD&time=',
	getArchiveByType: '/mobile/archive?type=GOLD&date=2020-09-10',
	getNews: '/tv/news',
	getSubscriptions: '/mobile/subscription',
	getSubscriptionsInfo: '/mobile/subscription-info?duration=3&price=2000000',
	buySubscriptions: '/mobile/subscription-payment'
}
